import React from 'react';
import MonthlyTrophyArt from '../design-system/badges/MonthlyTrophyArt';
import '../design-system/badges/ds-achievement-badge.css';
import '../design-system/badges/ds-placement-medal.css';
import './BadgeIcon.css';

const ORDINAL = { 1: '1st', 2: '2nd', 3: '3rd', 4: '4th' };

/**
 * The glyph for a badge wherever badges are listed.
 *
 * Most badges carry an emoji in `icon` and are shown as text. Monthly leaderboard
 * placement badges are drawn instead: the same shield and trophy-on-calendar art
 * the leaderboard shows (Leaderboard.js), so a member's shelf holds the badge they
 * saw awarded rather than a stand-in. Their `icon` column holds a DSIcon name, not
 * an emoji, and is not used for display.
 *
 * `size` is the medal width in px, picked to match the emoji slot it replaces. The
 * ribbon only appears at sizes where its text can be read; below that the rim
 * colour carries the placement, as it does at four-across on the leaderboard.
 */
export function isPlacementBadge(badge) {
  return badge?.criteria_config?.source === 'monthly_leaderboard';
}

function BadgeIcon({ badge, size = 40 }) {
  if (!isPlacementBadge(badge)) {
    return <>{badge?.icon || '🏅'}</>;
  }

  const position = Number(badge.criteria_config.position);
  const showRibbon = size >= 72;

  return (
    <figure
      className={`ds-achbadge ds-achbadge--medal-${position} badge-icon-medal`}
      style={{ '--achbadge-size': `${size}px` }}
      aria-label={badge.name}
      title={badge.name}
    >
      <span className="ds-achbadge__frame">
        <span className="ds-achbadge__inner" />
        <span className="ds-achbadge__art">
          <MonthlyTrophyArt />
        </span>
      </span>
      {showRibbon && <figcaption className="ds-achbadge__ribbon">{ORDINAL[position]}</figcaption>}
    </figure>
  );
}

export default BadgeIcon;
